const getInitials = (fullName = "") => {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "";

  const firstInitial = parts[0]?.[0] ?? "";
  const lastInitial = parts[1]?.[0] ?? "";
  return `${firstInitial}${lastInitial}`.toUpperCase();
};

export default getInitials;
